import { useNewUiContext } from '@savgroup-front-common/core/components/NewUiProvider/NewUiProvider';
import { GlobalStyle } from '@savgroup-front-common/core/helpers';
const GlobalStyleManager = () => {
  const { isDarkModeEnabled } = useNewUiContext();

  return (
    <GlobalStyle
      control
      $isDarkModeEnabled={isDarkModeEnabled}
    />
  );
};

export default GlobalStyleManager;
